import { Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import "./App.css";

const App = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
  </Routes>
);

export default App;
